import { FC, useState } from "react";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import CustomButton from "ui/Button";
import { ICON_NAMES } from "utils/constant";
import { useTranslation } from "react-i18next";
import CustomDropDownList from "ui/dropDown";
import { getBuyersFilterApi } from "api/common";
import { Vessel } from "interface/vessel";
import { ReleasedPackageFilter } from "api/package";
import { getVesselFilter } from "api/vessel";

interface CustomProps {
	exportAsPDF: () => void;
	exportAsExcel: () => void;
}
const Filter: FC<CustomProps> = ({ ...props }) => {
	return (
		<div className="filter-container">
			<div className="filter-end-btn released-package-filter-end-btn">
				<CustomButton
					label={"Pdf"}
					onClick={() => props.exportAsPDF()}
					iconName={ICON_NAMES.Download}
				/>
				<CustomButton
					label={"Excel"}
					onClick={() => props.exportAsExcel()}
					iconName={ICON_NAMES.Download}
				/>
			</div>
		</div>
	);
};

export default Filter;
